import { render, staticRenderFns } from "./CheckoutPage.vue?vue&type=template&id=04d5cf50&scoped=true&"
import script from "./CheckoutPage.vue?vue&type=script&lang=js&"
export * from "./CheckoutPage.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutPage.vue?vue&type=style&index=0&id=04d5cf50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d5cf50",
  null
  
)

export default component.exports